import {
  ASSESSMENT_TYPE_AI_TUTOR,
  ASSIGNMENT_TYPE_FORMATIVE,
  ASSIGNMENT_TYPE_LE,
  ASSIGNMENT_TYPE_QUICK_TASK,
  ASSIGNMENT_TYPE_SUMMATIVE,
  ASSIGNMENT_TYPE_WORKSHEET,
  EVIDENCE_TYPE_PROGRESS_REPORT,
  CURRICULUM_TYPE_PYP,
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_UBD,
  CURRICULUM_TYPE_DP,
  ELEMENT_TYPE_UBD_ATL,
  ELEMENT_TYPE_DP_ATL,
  ELEMENT_TYPE_PYP_ATL,
  ELEMENT_TYPE_UBD_LEARNING_STANDARD,
  ELEMENT_TYPE_DP_LEARNING_STANDARD,
  ELEMENT_TYPE_DP_OBJECTIVES,
  ELEMENT_TYPE_PYP_LEARNER_PROFILE,
  ELEMENT_TYPE_PYP_KEY_CONCEPT,
  ELEMENT_TYPE_ATL,
  ELEMENT_TYPE_LEARNER_PROFILE,
  ELEMENT_TYPE_CONCEPT,
  ELEMENT_TYPE_PYP_BENCHMARK,
  ELEMENT_TYPE_DP_SUBJECT,
  ELEMENT_TYPE_UBD_SUBJECT,
  ELEMENT_TYPE_MYP_ATL,
  ELEMENT_TYPE_MYP_SUBJECT,
  ELEMENT_TYPE_MYP_LEARNING_STANDARD,
  ELEMENT_TYPE_DP_LEARNER_PROFILE,
  ELEMENT_TYPE_IB_GRADE_ASSESSMENTS,
  ELEMENT_TYPE_ALL_ASSESSMENTS,
  ELEMENT_TYPE_GRADING_PERIOD_OVERVIEW,
  PLANNER_ELEMENT_SUMMARY,
  ELEMENT_TYPE_MYP_LEARNER_PROFILE,
} from "Constants/stringConstants";
import { colors } from "Constants";

export const STANDARDS_GRADEBOOK = "STUDENT_GRADEBOOK";
export const STUDENT_STANDARDS_GRADEBOOK = "STUDENT_STANDARDS_GRADEBOOK";

export const BAR_COLOR_BY_TYPE = {
  [ASSESSMENT_TYPE_AI_TUTOR]: colors.purple600,
  [ASSIGNMENT_TYPE_SUMMATIVE]: colors.teal600,
  [ASSIGNMENT_TYPE_WORKSHEET]: colors.pink600,
  [ASSIGNMENT_TYPE_LE]: colors.violet600,
  [ASSIGNMENT_TYPE_FORMATIVE]: colors.yellow600,
  [ASSIGNMENT_TYPE_QUICK_TASK]: colors.blue600,
  [EVIDENCE_TYPE_PROGRESS_REPORT]: colors.blue600,
};

// * List of element needs to show while new grading setup is enabled
export const ELEMENTS_FOR_NEW_GRADING_SETUP = [
  ELEMENT_TYPE_GRADING_PERIOD_OVERVIEW,
  ELEMENT_TYPE_ALL_ASSESSMENTS,
  STUDENT_STANDARDS_GRADEBOOK,
  "MYP_CRITERIA",
];

export const LEARNING_GOALS_ELEMENTS_FOR_NEW_GRADING = [
  ELEMENT_TYPE_PYP_ATL,
  ELEMENT_TYPE_PYP_LEARNER_PROFILE,
  ELEMENT_TYPE_PYP_KEY_CONCEPT,
  ELEMENT_TYPE_MYP_ATL,
  ELEMENT_TYPE_MYP_LEARNER_PROFILE,
  ELEMENT_TYPE_UBD_ATL,
  ELEMENT_TYPE_DP_ATL,
  ELEMENT_TYPE_DP_OBJECTIVES,
  ELEMENT_TYPE_DP_LEARNER_PROFILE,
];

const PYP_STUDENT_PROGRESS_SUMMARY_DETAILS_V2 = {
  summaryScreenDetails: [
    {
      key: ELEMENT_TYPE_GRADING_PERIOD_OVERVIEW,
      title: "progressSummary:overall_grades",
      uiType: ELEMENT_TYPE_GRADING_PERIOD_OVERVIEW,
      showTabs: true,
      familyPerm: "Common:EnableCategorywiseAndTermOverviewFamily",
      studentPerm: "Common:EnableCategorywiseAndTermOverviewStudent",
      group: "ASSESSMENTS_GRADEBOOK",
      routeKey: "grading-period-overview",
    },
    {
      key: ELEMENT_TYPE_ALL_ASSESSMENTS,
      title: "progressSummary:assessments",
      uiType: ELEMENT_TYPE_ALL_ASSESSMENTS,
      showTabs: true,
      showNestedSideBar: true,
      group: "ASSESSMENTS_GRADEBOOK",
      routeKey: "all-assessments",
    },
    {
      key: STUDENT_STANDARDS_GRADEBOOK,
      uiType: STANDARDS_GRADEBOOK,
      title: "common:standard_plural",
      useElementIdAsFilterForRating: true,
      ratingElementType: [ELEMENT_TYPE_PYP_BENCHMARK],
      group: STANDARDS_GRADEBOOK,
      groupTitleLocale: "classRoom:standards_gradebook",
      routeKey: "standards",
      showTabs: true,
    },
    {
      key: ELEMENT_TYPE_PYP_ATL,
      uiType: PLANNER_ELEMENT_SUMMARY,
      title: "common:atls_label",
      ratingElementType: ELEMENT_TYPE_ATL,
      rootNodePairFilterLabel: "common:skill_plural",
      group: "LEARNING_GOALS_GRADEBOOK",
      routeKey: "atl",
      showTabs: true,
    },
    {
      key: ELEMENT_TYPE_PYP_LEARNER_PROFILE,
      title: "planningInsights:lpa",
      uiType: PLANNER_ELEMENT_SUMMARY,
      ratingElementType: ELEMENT_TYPE_LEARNER_PROFILE,
      rootNodeStyleLevel: 1,
      group: "LEARNING_GOALS_GRADEBOOK",
      routeKey: "learner-profile",
      showTabs: true,
    },
    {
      key: ELEMENT_TYPE_PYP_KEY_CONCEPT,
      title: "common:concept_plural",
      uiType: PLANNER_ELEMENT_SUMMARY,
      ratingElementType: ELEMENT_TYPE_CONCEPT,
      group: "LEARNING_GOALS_GRADEBOOK",
      routeKey: "key-concepts",
      showTabs: true,
    },
    {
      key: ELEMENT_TYPE_PYP_BENCHMARK,
      title: "common:sns",
      useElementIdAsFilterForRating: true,
      uiType: PLANNER_ELEMENT_SUMMARY,
      ratingElementType: ELEMENT_TYPE_PYP_BENCHMARK,
      group: "LEARNING_GOALS_GRADEBOOK",
      routeKey: "benchmarks",
      showTabs: true,
    },
  ],
};

const MYP_STUDENT_PROGRESS_SUMMARY_DETAILS_V2 = {
  summaryScreenDetails: [
    {
      key: ELEMENT_TYPE_GRADING_PERIOD_OVERVIEW,
      title: "progressSummary:overall_grades",
      uiType: ELEMENT_TYPE_GRADING_PERIOD_OVERVIEW,
      showTabs: true,
      familyPerm: "Common:EnableCategorywiseAndTermOverviewFamily",
      studentPerm: "Common:EnableCategorywiseAndTermOverviewStudent",
      group: "ASSESSMENTS_GRADEBOOK",
      routeKey: "grading-period-overview",
    },
    {
      key: ELEMENT_TYPE_ALL_ASSESSMENTS,
      title: "progressSummary:assessments",
      uiType: ELEMENT_TYPE_ALL_ASSESSMENTS,
      showTabs: true,
      showNestedSideBar: true,
      group: "ASSESSMENTS_GRADEBOOK",
      routeKey: "all-assessments",
    },
    {
      key: STUDENT_STANDARDS_GRADEBOOK,
      uiType: STANDARDS_GRADEBOOK,
      title: "common:standard_plural",
      useElementIdAsFilterForRating: true,
      ratingElementType: [ELEMENT_TYPE_MYP_LEARNING_STANDARD],
      group: STANDARDS_GRADEBOOK,
      groupTitleLocale: "classRoom:standards_gradebook",
      routeKey: "standards",
      showTabs: true,
    },
    {
      key: "MYP_CRITERIA",
      title: "progressSummary:myp_criteria",
      group: "ASSESSMENTS_GRADEBOOK",
      routeKey: "criteria",
    },
    {
      key: ELEMENT_TYPE_MYP_ATL,
      uiType: PLANNER_ELEMENT_SUMMARY,
      title: "common:atls_label",
      showRatingsFilter: true,
      group: "LEARNING_GOALS_GRADEBOOK",
      routeKey: "atl",
      showTabs: true,
    },
    {
      key: ELEMENT_TYPE_MYP_LEARNING_STANDARD,
      uiType: PLANNER_ELEMENT_SUMMARY,
      title: "common:sns",
      useElementIdAsFilterForRating: true,
      ratingElementType: [
        ELEMENT_TYPE_MYP_LEARNING_STANDARD,
        ELEMENT_TYPE_MYP_SUBJECT,
      ],
      group: "LEARNING_GOALS_GRADEBOOK",
      routeKey: "learning-standards",
      showTabs: true,
    },
    {
      key: "REPORT_OVERVIEW",
      title: "studentProgressSummary:progress_report_overview",
      group: "OTHER_VIEWS",
      routeKey: "report-overview",
    },
    {
      key: "SLO",
      title: "project:service_learning_outcomes",
      group: "OTHER_VIEWS",
      routeKey: "learning-outcomes",
    },
    {
      key: ELEMENT_TYPE_MYP_LEARNER_PROFILE,
      uiType: PLANNER_ELEMENT_SUMMARY,
      title: "planningInsights:lpa",
      showRatingsFilter: true,
      rootNodeStyleLevel: 1,
      group: "LEARNING_GOALS_GRADEBOOK",
      routeKey: "learner-profile",
      showTabs: true,
    },
  ],
};

const UBD_STUDENT_PROGRESS_SUMMARY_DETAILS_V2 = {
  summaryScreenDetails: [
    {
      key: ELEMENT_TYPE_GRADING_PERIOD_OVERVIEW,
      title: "progressSummary:overall_grades",
      uiType: ELEMENT_TYPE_GRADING_PERIOD_OVERVIEW,
      showTabs: true,
      familyPerm: "Common:EnableCategorywiseAndTermOverviewFamily",
      studentPerm: "Common:EnableCategorywiseAndTermOverviewStudent",
      group: "ASSESSMENTS_GRADEBOOK",
      routeKey: "grading-period-overview",
    },
    {
      key: ELEMENT_TYPE_ALL_ASSESSMENTS,
      title: "progressSummary:assessments",
      showTabs: true,
      uiType: ELEMENT_TYPE_ALL_ASSESSMENTS,
      showNestedSideBar: true,
      group: "ASSESSMENTS_GRADEBOOK",
      routeKey: "all-assessments",
    },
    {
      key: STUDENT_STANDARDS_GRADEBOOK,
      uiType: STANDARDS_GRADEBOOK,
      title: "common:standard_plural",
      useElementIdAsFilterForRating: true,
      ratingElementType: [ELEMENT_TYPE_UBD_LEARNING_STANDARD],
      group: STANDARDS_GRADEBOOK,
      groupTitleLocale: "classRoom:standards_gradebook",
      routeKey: "standards",
      showTabs: true,
    },
    {
      key: ELEMENT_TYPE_UBD_ATL,
      uiType: PLANNER_ELEMENT_SUMMARY,
      title: "common:ubd_skills",
      rootNodePairFilterLabel: "common:skill_plural",
      group: "LEARNING_GOALS_GRADEBOOK",
      routeKey: "atl",
      showTabs: true,
    },
    {
      key: ELEMENT_TYPE_UBD_LEARNING_STANDARD,
      uiType: PLANNER_ELEMENT_SUMMARY,
      title: "common:sns",
      useElementIdAsFilterForRating: true,
      ratingElementType: [
        ELEMENT_TYPE_UBD_LEARNING_STANDARD,
        ELEMENT_TYPE_UBD_SUBJECT,
      ],
      group: "LEARNING_GOALS_GRADEBOOK",
      routeKey: "learning-standards",
      showTabs: true,
    },
  ],
};

const DP_STUDENT_PROGRESS_SUMMARY_DETAILS_V2 = {
  summaryScreenDetails: [
    {
      key: ELEMENT_TYPE_GRADING_PERIOD_OVERVIEW,
      title: "progressSummary:overall_grades",
      uiType: ELEMENT_TYPE_GRADING_PERIOD_OVERVIEW,
      showTabs: true,
      showAcademicYearsFilter: true,
      familyPerm: "Common:EnableCategorywiseAndTermOverviewFamily",
      studentPerm: "Common:EnableCategorywiseAndTermOverviewStudent",
      group: "ASSESSMENTS_GRADEBOOK",
      routeKey: "grading-period-overview",
    },
    {
      key: ELEMENT_TYPE_ALL_ASSESSMENTS,
      title: "progressSummary:assessments",
      uiType: ELEMENT_TYPE_ALL_ASSESSMENTS,
      showTabs: true,
      showNestedSideBar: true,
      showAcademicYearsFilter: true,
      group: "ASSESSMENTS_GRADEBOOK",
      routeKey: "all-assessments",
    },
    {
      key: STUDENT_STANDARDS_GRADEBOOK,
      uiType: STANDARDS_GRADEBOOK,
      title: "common:standard_plural",
      useElementIdAsFilterForRating: true,
      ratingElementType: [ELEMENT_TYPE_DP_LEARNING_STANDARD],
      group: STANDARDS_GRADEBOOK,
      groupTitleLocale: "classRoom:standards_gradebook",
      routeKey: "standards",
      showTabs: true,
    },
    {
      key: ELEMENT_TYPE_IB_GRADE_ASSESSMENTS,
      title: "common:IB_grade_across_assessments",
      uiType: ELEMENT_TYPE_IB_GRADE_ASSESSMENTS,
      showNestedSideBar: true,
      showAcademicYearsFilter: true,
      group: "ASSESSMENTS_GRADEBOOK",
      routeKey: "grade-assessments",
    },
    {
      key: ELEMENT_TYPE_DP_ATL,
      uiType: PLANNER_ELEMENT_SUMMARY,
      title: "common:atls_label",
      showTabs: true,
      showRatingsFilter: true,
      showAcademicYearsFilter: true,
      group: "LEARNING_GOALS_GRADEBOOK",
      routeKey: "atl",
    },
    {
      key: ELEMENT_TYPE_DP_LEARNING_STANDARD,
      uiType: PLANNER_ELEMENT_SUMMARY,
      title: "common:sns",
      showTabs: true,
      showAcademicYearsFilter: true,
      useElementIdAsFilterForRating: true,
      ratingElementType: [
        ELEMENT_TYPE_DP_LEARNING_STANDARD,
        ELEMENT_TYPE_DP_SUBJECT,
      ],
      group: "LEARNING_GOALS_GRADEBOOK",
      routeKey: "learning-standard",
    },
    {
      key: ELEMENT_TYPE_DP_OBJECTIVES,
      uiType: PLANNER_ELEMENT_SUMMARY,
      title: "common:DP_OBJECTIVES_label",
      showTabs: true,
      useElementIdAsFilterForRating: true,
      rootNodeStyleLevel: 1,
      showAcademicYearsFilter: true,
      group: "LEARNING_GOALS_GRADEBOOK",
      routeKey: "assessment-objective",
    },
    {
      key: ELEMENT_TYPE_DP_LEARNER_PROFILE,
      uiType: PLANNER_ELEMENT_SUMMARY,
      title: "planningInsights:lpa",
      showTabs: true,
      showRatingsFilter: true,
      rootNodeStyleLevel: 1,
      showAcademicYearsFilter: true,
      group: "LEARNING_GOALS_GRADEBOOK",
      routeKey: "learner-profile",
    },
  ],
};

export const STUDENT_PROGRESS_SUMMARY_DETAILS_MAP = {
  [CURRICULUM_TYPE_PYP]: PYP_STUDENT_PROGRESS_SUMMARY_DETAILS_V2,
  [CURRICULUM_TYPE_MYP]: MYP_STUDENT_PROGRESS_SUMMARY_DETAILS_V2,
  [CURRICULUM_TYPE_UBD]: UBD_STUDENT_PROGRESS_SUMMARY_DETAILS_V2,
  [CURRICULUM_TYPE_DP]: DP_STUDENT_PROGRESS_SUMMARY_DETAILS_V2,
};

export const SECTIONS_TITLE_LOCALES_MAP = {
  [STANDARDS_GRADEBOOK]: "classRoom:standards_gradebook",
};
